import OSS from "ali-oss";
import http from "../api";

export const uploadOss = (
  file,
  bucket = "onyx-edu",
  key = "cover",
  region = "oss-cn-shenzhen"
) => {
  let randomName =
    random_string(6) +
    "_" +
    new Date().getTime() +
    "." +
    file.name.split(".").pop();
  return new Promise(async (resolve, reject) => {
    let sts = await http.aliyunSts();
    let client = await new OSS({
      region,
      accessKeyId: sts.data.AccessKeyId,
      accessKeySecret: sts.data.AccessKeySecret,
      stsToken: sts.data.SecurityToken,
      bucket
    });
    let coverData = await client.multipartUpload(
      `${key}/${randomName}`,
      file.raw
    );
    if (key === "neocloud_admin") {
      resolve({ key: coverData.name, bucket, name: file.name });
    } else {
      resolve(coverData.res.requestUrls[0].split("?")[0]);
    }
  });
};

const random_string = len => {
  len = len || 32;
  var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  var maxPos = chars.length;
  var pwd = "";
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
};

export const uploadAliyun = files => {
  return new Promise(async (resolve, reject) => {
    for (let file of files) {
      // 上传
      resolve(await uploadOss(file));
    }
  });
};
